module.exports = __webpack_public_path__ + "static/media/1009829.aaa685ac.jpg";